import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import { connect } from 'react-redux';
import visuallyHidden from 'styles/visuallyHidden';

const styles = {
  hidden: visuallyHidden,
};

const ErrorAnnounce = ({ classes, fields, groups, page }) => (
  <div className={classnames('hidden', classes.hidden)} aria-live="assertive">
    <ul>
      {page.errorMsg ? `<li>${page.errorMsg}</li>` : ''}
      {groups.map((group) => (
        <li key={group.name}>{group.errorMsg}</li>
      ))}
      {fields.map((field) => (
        <li key={field.clientId}>{field.errorMsg}</li>
      ))}
    </ul>
  </div>
);

ErrorAnnounce.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape()),
  groups: PropTypes.arrayOf(PropTypes.shape()),
  page: PropTypes.shape().isRequired,
};

ErrorAnnounce.defaultProps = {
  fields: [],
  groups: [],
};

const mapStateToProps = ({ fields, groups, page }) => ({
  fields: Object.keys(fields)
    .filter((k) => fields[k].error)
    .map((k) => fields[k]),
  groups: Object.keys(groups)
    .filter((k) => groups[k].error)
    .map((k) => groups[k]),
  page,
});

const StyledErrorAnnounce = withStyles(styles)(ErrorAnnounce);

export default connect(mapStateToProps)(StyledErrorAnnounce);
